<div class="pop-inputs pop-datatable pop-datatable-simple pop-department-modal">

  <div class="dialog-title">
    {{ departmentLabel }}
  </div>
  <div *ngIf="rows"
       class="body">

    <p-table #departmentTable
             [globalFilterFields]="['code', 'description']"
             [value]="rows"
             [scrollable]="true"
             scrollHeight="flex">
      <!-- search, export -->
      <ng-template pTemplate="caption">
        <div class="pop-display-flex dept-search-box">
          <i class="far fa-search"></i>
          <input type="text"
                 pInputText
                 size="50"
                 (input)="filterTable(departmentTable, $event.target)"
                 class="input-filter" />
        </div>

      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="checkbox-column"></th>
          <th class="code-column"
              translate="MODAL.CODE"></th>
          <th translate="MODAL.DESC"></th>
          <th class="resource-column"
              translate="MODAL.MANAGER"></th>
          <th class="association-column"
              translate="MODAL.ASSOCIATION">
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body"
                   let-row
                   let-editing="editing"
                   let-rowIndex="rowIndex">
        <tr [pSelectableRow]="row"
            [pEditableRow]="row">
          <td class="checkbox-column"
              [class.read-only]="!isStatusTypeNew || isGroupApproved">

            <div (click)="toggleDepartment($event, row)">
              <pop-checkbox [isChecked]="row.departmentEstimate"></pop-checkbox>
            </div>

          </td>
          <td class="code-column">{{ row.code }}</td>
          <td>{{ row.description }}</td>
          <td class="resource-column">
            <pop-resource-picker [disabled]="!isStatusTypeNew || isGroupApproved || !row.departmentEstimate"
                                 *ngIf="row.departmentEstimate"
                                 [(selectedResource)]="row.responsible"
                                 [isManagersOnly]="true"></pop-resource-picker>
          </td>
          <td class="association-column"
              [class.disabled]="!row.departmentEstimate || !isStatusTypeNew || isGroupApproved || isEmptyTree">
            <div>
              <div class="toggle"
                   [matTooltip]="'BUTTON.APPLY_ALL' | translate"
                   (click)="toggleIsAssociatedToAllStructures(row, $event)">
                <pop-switch [isSwitched]="row.departmentEstimate?.isAssociatedToAllStructures">
                </pop-switch>
              </div>

              <i class="far fa-link"
                 [matTooltip]="'BUTTON.DETAILED_ASSO' | translate"
                 (click)="openDetailedStructureAssociation(row)"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
